// extracted by mini-css-extract-plugin
export var standaloneTable = "_g1-0";
export var standaloneTableWithBodyFill = "_g1-1";
export var withExtraHeader = "_g1-2";